import { classNames } from 'libs/react';
import { useState } from 'libs/react';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import { ModalImport } from './modal/ModalImport';
import { useMemo } from 'react';
import { ImportSaleItemsMutation } from 'graphql/SaleItem/mutations/ImportSaleItemsMutation';
import { ImportSaleItemOptionsMutation } from 'graphql/SaleItem/mutations/ImportSaleItemOptionsMutation';
import { ImportSaleItemOptionRelationsMutation } from 'graphql/SaleItem/mutations/ImportSaleItemOptionRelationsMutation';
import { ImportSaleItemRelationsMutation } from 'graphql/SaleItem/mutations/ImportSaleItemRelationsMutation';
import { ExportSaleItemOptionsMutation } from 'graphql/SaleItem/mutations/ExportSaleItemOptionsMutation';
import { ExportSaleItemOptionRelationsMutation } from 'graphql/SaleItem/mutations/ExportSaleItemOptionRelationsMutation';
import { ExportSaleItemRelationsMutation } from 'graphql/SaleItem/mutations/ExportSaleItemRelationsMutation';
import { ImportSaleItemVariantsMutation } from 'graphql/SaleItemVariant/mutations/ImportSaleItemVariantsMutation';
import { ImportSaleItemVariantOptionsMutation } from 'graphql/SaleItemVariant/mutations/ImportSaleItemVariantOptionsMutation';
import { ImportSaleItemVariantOptionRelationsMutation } from 'graphql/SaleItemVariant/mutations/ImportSaleItemVariantOptionRelationsMutation';
import { ExportSaleItemVariantOptionsMutation } from 'graphql/SaleItemVariant/mutations/ExportSaleItemVariantOptionsMutation';
import { ExportSaleItemVariantOptionRelationsMutation } from 'graphql/SaleItemVariant/mutations/ExportSaleItemVariantOptionRelationsMutation';
import './ImportButton.scss';
/**
 * @component ImportButton
 * @since 1.0.0
 * @hidden
 */
export function ImportButton(props) {
    const { templateMutation: templateMutationProp, refetchQuery, refetchQueryFieldName, refetchQueryVariables, picto, itemOnly, isEndClient, label, optionOnly, manufacturing, style, isSaleItem, entityId } = Object.assign({ style: 'normal', picto: 'upload' }, props);
    const [openModal, setOpenModal] = useState(false);
    const [optionConfiguration, setOptionConfiguration] = useState('');
    /**
     * @function onClickExport
     * @since 1.0.0
     * @hidden
     */
    const onClickImport = () => {
        setOpenModal(true);
    };
    /**
     * @function onClose
     * @since 1.0.0
     * @hidden
     */
    const onClose = () => {
        setOpenModal(false);
    };
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    const onChange = (value) => {
        setOptionConfiguration(value);
    };
    const importMutation = useMemo(() => {
        if (isSaleItem) {
            if (optionConfiguration === 'ITEM_ONLY') {
                return ImportSaleItemsMutation;
            }
            if (optionConfiguration === 'OPTION_ONLY') {
                return ImportSaleItemVariantsMutation;
            }
            if (optionConfiguration === 'ITEM_OPTIONS') {
                return ImportSaleItemOptionsMutation;
            }
            if (optionConfiguration === 'VARIANT_OPTIONS') {
                return ImportSaleItemVariantOptionsMutation;
            }
            if (optionConfiguration === 'ITEM_RELATIONS') {
                return ImportSaleItemRelationsMutation;
            }
            if (optionConfiguration === 'ITEM_OPTION_RELATIONS') {
                return ImportSaleItemOptionRelationsMutation;
            }
            if (optionConfiguration === 'VARIANT_OPTION_RELATIONS') {
                return ImportSaleItemVariantOptionRelationsMutation;
            }
        }
        return props.importMutation;
    }, [props.importMutation, optionConfiguration]);
    const templateMutation = useMemo(() => {
        if (isSaleItem) {
            if (optionConfiguration === 'ITEM_OPTIONS') {
                return ExportSaleItemOptionsMutation;
            }
            if (optionConfiguration === 'VARIANT_OPTIONS') {
                return ExportSaleItemVariantOptionsMutation;
            }
            if (optionConfiguration === 'ITEM_RELATIONS') {
                return ExportSaleItemRelationsMutation;
            }
            if (optionConfiguration === 'ITEM_OPTION_RELATIONS') {
                return ExportSaleItemOptionRelationsMutation;
            }
            if (optionConfiguration === 'VARIANT_OPTION_RELATIONS') {
                return ExportSaleItemVariantOptionRelationsMutation;
            }
        }
        return templateMutationProp;
    }, [templateMutationProp, optionConfiguration]);
    const className = classNames('import-button', 'import-button--' + style, { 'import-button--has-label': label }, { 'import-button--has-picto': picto });
    return (React.createElement("div", null,
        React.createElement("button", { className: className, onClick: onClickImport, type: "button" },
            picto && React.createElement(Icon, { className: "import-button-picto", value: picto }),
            label && React.createElement(Text, { className: "import-button-label", value: label })),
        openModal && (React.createElement(ModalImport, { onClose: onClose, importMutation: importMutation, templateMutation: templateMutation, refetchQuery: refetchQuery, refetchQueryFieldName: refetchQueryFieldName, refetchQueryVariables: refetchQueryVariables, importSuccess: props.importSuccess, isEndClient: isEndClient, isSaleItem: isSaleItem, entityId: entityId, onOptionConfigurationChange: onChange, itemOnly: itemOnly, optionOnly: optionOnly, manufacturing: manufacturing }))));
}
